<template>
  <!-- RolesManage -->
  <el-tab-pane label="RolesManage">
    <div>
      <div class="row">
        <div class="col-sm-12">
          <el-card>
            <h4 style="color: #3b291d">RolesManage</h4>
            <!-- Start search part -->

            <div class="row">
              <div class="col-sm-2">
                <base-input label="RoleName">
                  <el-input
                    placeholder="RoleName"
                    clearable
                    style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    "
                    v-model="searchKeyRoles.name"
                  ></el-input>
                </base-input>
              </div>
              <div class="col-sm-2">
                <base-input label="Status" :clearable="true">
                  <el-select v-model="searchKeyRoles.status" class="select-primary" filterable size="large"
                    placeholder="Status">
                    <el-option label="all" :value="null"> </el-option>
                    <el-option label="active" value="active"> </el-option>
                    <el-option label="inactive" value="inactive"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-3">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div
                    style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    "
                  >
                    <base-button
                      type="primary"
                      @click="searchRoles"
                      style="width: 100px"
                      >Search</base-button
                    >
                    <base-button
                      type="primary"
                      @click="resetRoles"
                      style="width: 100px"
                      >Reset</base-button
                    >
                  </div>
                </div>
              </div>
      
            </div>
            <div class="row">
             
            </div>
            <!-- end Search part-->
            <div class="row" style="margin-top: 20px">
              <div class="col-sm-12" style="display: flex">
                <div class="col-sm-3" >
                <el-link type="primary" @click="OpenTestRoles"
                  >Add Roles</el-link
                >
              </div>
                <span
                  style="
                    margin-left: auto;
                    line-height: 32px;
                    padding-right: 20px;
                  "
                >
                  <el-pagination
                    v-model:current-page="currentPage"
                    v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :small="small"
                    :background="true"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchKeyRoles.total"
                    @size-change="ChangePageSearchRoles"
                    @current-change="ChangePageSearchRoles"
                  />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-table
                  :data="Roleslist"
                  style="width: 100%"
                  border
                  header-row-class-name="header-row"
                  @filter-change="searchRoles"
                  table-layout="auto"
                  cell-class-name="report-cell"
                >
                  <tablecolumn prop="name" label="RoleName"  :width="240" />
                  <el-table-column prop="status" label="status" :width="140" />
                  <tablecolumn
                    prop="description"
                    label="description"
                    :width="140"
                  />
                  <tablecolumn prop="roleNo" label="roleNo" :width="200" />
                  <tablecolumn prop="remark" label="remark" :width="200" />

                  <el-table-column
                    prop="created_at"
                    label="created_at"
                    :width="200"
                  />
                  <el-table-column
                    prop="created_by"
                    label="created_by"
                    :width="120"
                  />
                  <el-table-column
                    prop="updated_at"
                    label="updated_at"
                    :width="200"
                  />
                  <el-table-column
                    prop="updated_by"
                    label="updated_by"
                    :width="120"
                  />

                  <el-table-column
                    prop=""
                    fixed="right"
                    label="Action"
                    class-name="action"
                  >
                    <template #default="scope">
                      <el-link
                        type="primary"
                        @click="OpenUpdateRoles(scope.row)"
                        >Update Roles</el-link
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        v-model="dialogFormRoles"
        title="Test RolesFunctions"
        width="80%"
      >
        <el-form :model="RolesInfoData" :inline="true">
          <el-form-item label="RoleName" :label-width="formLabelWidth" required>
            <el-input v-model="RolesInfoData.value.name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="status" :label-width="formLabelWidth" required>
            <el-select v-model="RolesInfoData.value.status">
              <el-option label="active" value="active" />
              <el-option label="inactive" value="inactive" />
            </el-select>
          </el-form-item>
          <el-form-item label="remark" :label-width="formLabelWidth" >
            <el-input v-model="RolesInfoData.value.remark" autocomplete="off" />
          </el-form-item>
          <el-form-item label="description" :label-width="formLabelWidth" >
            <el-input v-model="RolesInfoData.value.description" autocomplete="off" />
          </el-form-item>
        
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormRoles = false"
              >Cancel</el-button
            >
            <el-button type="primary" @click="AddRoles"> Confirm </el-button>
          </span>
        </template>
        <div>
          <el-row>
            <el-col :span="11">
              <span style="font-weight: 700; color: blue">BUS</span>
              <el-scrollbar height="600px" style="width: 100%">
                <el-table
                  :data="listBus"
                  style="width: 99%"
                  height="600"
                  border
                >
                  <el-table-column prop="isCheck" label="" :width="70">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.isCheck"
                        @change="changeCheckBus(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="name" label="FunctionsName" />
                  <el-table-column prop="create" label="create" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.create"
                        @change="changeCheckBus(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="write" label="write" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.write"
                        @change="changeCheckBus(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="read" label="read" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.read"
                        @change="changeCheckBus(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="delete" label="delete" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.delete"
                        @change="changeCheckBus(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="approve" label="approve" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.approve"
                        @change="changeCheckBus(scope.$index)"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="otherFunction"
                    label="otherFunction"
                    :width="120"
                  >
                    <template #default="scope">
                      <el-switch v-model="scope.row.otherFunction" />
                    </template>
                  </el-table-column>
                </el-table>
              </el-scrollbar>
            </el-col>
            <el-col :span="1"> </el-col>
            <el-col :span="12">
              <span style="font-weight: 700; color: blue">Billboard</span>
              <el-scrollbar height="600px" style="width: 100%">
                <el-table
                  :data="listBB"
                  style="width: 100%"
                  height="600"
                  border
                >
                  <el-table-column prop="isCheck" label="" :width="70">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.isCheck"
                        @change="changeCheckBB(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="name" label="FunctionsName" />
                  <el-table-column prop="create" label="create" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.create"
                        @change="changeCheckBB(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="write" label="write" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.write"
                        @change="changeCheckBB(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="read" label="read" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.read"
                        @change="changeCheckBB(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="delete" label="delete" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.delete"
                        @change="changeCheckBB(scope.$index)"
                      /> </template
                  ></el-table-column>
                  <el-table-column prop="approve" label="approve" :width="80">
                    <template #default="scope">
                      <el-switch
                        v-model="scope.row.approve"
                        @change="changeCheckBB(scope.$index)"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="otherFunction"
                    label="otherFunction"
                    :width="120"
                  >
                    <template #default="scope">
                      <el-switch v-model="scope.row.otherFunction" />
                    </template>
                  </el-table-column>
                </el-table>
              </el-scrollbar>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </el-tab-pane>
</template>

<script setup>
// import './css/index.css';
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';

const formLabelWidth = '90px';
const currentPage = ref(1);
const pageSize = ref(10);
const tabkey = ref('UserManage');

// router
import router from '@/router';
import profile from '@/network/profile';

// icon
import { Edit, Search } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';
onBeforeMount(async () => {
  await searchRoles();
});

//#region   Roles

const dialogFormRoles = ref(false);
const RolesInfoData = reactive({});
const Roleslist = ref([]);
const listBB = ref([]);
const listBus = ref([]);
const listBB1 = ref([]);
const listBus1 = ref([]);
//变更分页
const ChangePageSearchRoles = async (data) => {
  searchKeyRoles.pageIndex = currentPage;
  searchKeyRoles.pageSize = pageSize;
  searchRoles();
};
//搜索条件实体
const searchKeyRoles = reactive({
  pageIndex: 1,
  pageSize: 10,
  status: 'active',
});
//搜索
const searchRoles = async () => {
  const search_res = await profile
    .GetRolesList(searchKeyRoles)
    .then((res) => res);
  searchKeyRoles.total = search_res.data.total;
  Roleslist.value = search_res.data.list;
  listBB1.value = JSON.parse(JSON.stringify(search_res.data.listBB));
  listBus1.value = JSON.parse(JSON.stringify(search_res.data.listBus));
};

const resetRoles = async () => {
  //清空对象
  Object.keys(searchKeyRoles).map((key) => {
    delete searchKeyRoles[key];
  });
  searchKeyRoles.pageIndex = 1;
  searchKeyRoles.pageSize = 10;
  searchKeyRoles.status = 'active';
  searchRoles();
};

const changeCheckBus = (index) => {
  listBus.value[index].isChange = true;
};
const changeCheckBB = (index) => {
  listBB.value[index].isChange = true;
};

const OpenTestRoles = async (data) => {
  RolesInfoData.value = {};
  listBB.value = listBB1.value;
  listBus.value = listBus1.value;
  dialogFormRoles.value = true;
};
//添加Roles
const AddRoles = async (data) => {
  dialogFormRoles.value = false;
  RolesInfoData.value.listBB=listBB.value;
  RolesInfoData.value.listBus=listBus.value;
  const result = await profile.AddRoles(RolesInfoData.value).then((res) => res);
  if (result.data === '') {
    ElMessage({
      message: '操作成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
  }
  await searchRoles();
};
//打开修改窗口
const OpenUpdateRoles = async (data) => {
  dialogFormRoles.value = true;
  RolesInfoData.value = data;
  console.log(11111, data);
  listBB.value = JSON.parse(data.listBB1);
  listBus.value = JSON.parse(data.listBus1);
};

//#endregion

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    searchKeyRoles[`${data.key}`] = data.value;
    searchRoles();
  });
});
</script>

<style scoped>
.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
